import React, { useState, useEffect } from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { Feather, MaterialIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from "@react-navigation/native";
import { formatGPXBalance } from '../../utils/formatNumber'
import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../../services/api";

import styles from "./styles";

const Header = ({ route, loading, nameuser }) => {
  const navigation = useNavigation();

  const [saldo, setSaldo] = useState(0);
  const [showBalance, setShowBalance] = useState(true);

  useEffect(() => {
    getBalanceCoin();
  }, []);
  const getBalanceCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    loading(true)
    api.get("balanceGpxcoin", { headers: { Authorization: `Basic ${token}` } })
      .then((res) => {
        if (res.data.balance[0]?.available_balance) {
          setSaldo(res.data.balance[0].available_balance);
        } else {
          setSaldo(res.data.balance[0].saldo);
        }
        loading(false)
      })
      .catch((error) => {
        console.log("erro555", error);
        loading(false)
      });
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {route !== undefined ? (
          <Feather
            name="settings"
            size={24}
            color="#fff"
            style={styles.iconsHeader}
            onPress={() => navigation.navigate(route)}
          />
        ) : (
          <MaterialIcons
            name="keyboard-arrow-left"
            size={30}
            color="#fff"
            style={styles.iconsHeader}
            onPress={() => navigation.goBack()}
          />
        )}
        <View style={styles.contentDataUser}>
          <LinearGradient
            colors={["#16195B", "#1FBFB5"]}
            style={styles.borderProfile}
          >
            <Image
              source={require("../../../assets/profile_default.jpg")}
              style={styles.imgProfile}
            />
          </LinearGradient>

          <Text style={styles.textNameUser}>
            <Text>Olá, </Text><Text numberOfLines={3} style={styles.textBold}>{nameuser}</Text>
          </Text>
          <Text style={styles.textBalanceUser}>
            Seu saldo é:{" "}
            <Text style={styles.textBold}>
              {showBalance ? formatGPXBalance(saldo) : "*****"} GPX
            </Text>{" "}
            <TouchableOpacity onPress={() => setShowBalance(!showBalance)}>
              {showBalance ? (
                <Feather name="eye-off" size={16} color="#fff" />
              ) : (
                <Feather name="eye" size={16} color="#fff" />
              )}
            </TouchableOpacity>
          </Text>
          <View style={styles.hrLine}></View>
          <Text style={styles.textExtractUser}></Text>
        </View>

        <View />
        {/* View temporária só para substituir icone de notificações */}
        {/* <Feather
          name="bell"
          size={24}
          color="#fff"
          style={styles.iconsHeader}
        /> */}
      </View>
    </View>
  );
};

export default Header;
